import { render, staticRenderFns } from "./SVG-WhitechapelBldgs.vue?vue&type=template&id=5d3a3173&"
import script from "./SVG-WhitechapelBldgs.vue?vue&type=script&lang=js&"
export * from "./SVG-WhitechapelBldgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports